import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CreateBody } from './create-body';
import { CreateGenericNavigation } from './navigation/create-generic-navigation';
import { CreateInsertNavigation } from './navigation/create-insert-navigation';

export const CreateNavigationSwitch = () => {
  return <StepNavigationSwitch body={CreateBody} generic={CreateGenericNavigation} insert={CreateInsertNavigation} />;
};
